const LINKS = {
  ABOUT_US: '/about-us/',
  AUTH: {
    LOGIN: '/auth/',
    CONFIRM: '/auth/confirm/',
    SCRIPT: '/auth/confirm/script/',
    LOGOUT: '/auth/logout/',
    SHAD_LOGOUT: '/auth/logout/shad/',
    MULTI_DEVICE_LOGOUT: '/auth/logout/multi-device/',
  },
  BLOG: '/blog/',
  CONTACT_US: '/contact-us/',
  COURSE: '/app/media/[id]/',
  DISCOVER: '/discover/',
  DISCOVER_CATEGORY: '/discover/[id]/',
  GRADE: '/app/',
  HOME: '/',
  LANDING: {
    RUBIKA: '/rubika/',
    SHAD: '/shad/',
  },
  LEARNING: '/app/learning/',
  LESSON: '/app/learning/[gradeSlug]/[lessonSlug]/',
  LESSONS: '/app/learning/[gradeSlug]/',
  LESSON_SECTION: '/app/media/[id]/',
  LIVE: '/live/',
  PROFILE: {
    DEFAULT: '/profile/',
    INFORMATION: '/profile/information/',
    SUBSCRIPTION: '/profile/subscription/',
    SUBSCRIPTION_SINGLE: '/profile/subscription/single/',
    TRANSITION: '/profile/transition/',
    MESSAGE: '/profile/message/',
    NOTIFICATION: '/profile/notification/',
    DOWNLOAD: '/profile/download/',
    BOOKMARK: '/profile/bookmarks/',
    LIKE: '/profile/likes/',
  },
  QUESTION: '/question/',
  RULES: '/policy/',
  SEARCH: '/search/',
  SUBSCRIPTION: {
    ITEM: '/subscription/[id]/',
    MAIN: '/subscription/',
    TIZHOUSHAN: `/subscription/${encodeURIComponent('تیزهوشان')}/`,
    KONKOUR: `/subscription/${encodeURIComponent('کنکور')}/`,
    BUY: '/subscription/thank-you/',
    BUY_SUCCESS: '/subscription/thank-you/success/',
  },
  TEACHER: '/teacher/[id]/',
  TEACHER_LIST: '/teacher/',
  WORKSPACE: {
    MAIN: '/workspace/',
  },
};

export default LINKS;
